import React from "react";
import { Button, Card, Flex, notification } from "antd";
import BannersApi from "../../api-services/banners-api.service";
import { Banner } from "../../interfaces/banner.interface";
import { mdiChevronLeft, mdiChevronRight } from "@mdi/js";
import Icon from "@mdi/react";
import LocationTabs from "../../components/shared/LocationTabs";
import DestinationsHighlight from "./DestinationsHighlight";
import PostsApi from '../../api-services/posts-api.service';
import { Post } from "../../interfaces/post.interface";
import { Link } from "react-router-dom";
import Banners from "../../components/shared/Banners";
import LocationsApi from "../../api-services/locations-api.service";
import SearchBarWidget from "./SearchBarWidget";

const { Meta } = Card;

interface IHomepageState {
  banners: Banner[],
  whatsNew: Post[],
  newsAndEvents: Post[],
  classics: Location[],
  inDepth: Location[],
}

export default class Homepage extends React.Component {
  bannersApi = new BannersApi;
  postsApi = new PostsApi;
  locationsApi = new LocationsApi;

  state:IHomepageState = {
    banners: [],
    whatsNew: [],
    newsAndEvents: [],
    classics: [],
    inDepth: [],
  }


  componentDidMount() {
    Promise.all([
      this.bannersApi.getBanners(),
      this.postsApi.getPosts('whats_new'),
      this.postsApi.getPosts('news_and_events', 1, {limit: 4}),
      this.locationsApi.getLocations({group: 'GD_Standard', homepage: true}),
      this.locationsApi.getLocations({group: 'GD_In_Depth', homepage: true}),
    ]).then(([banners, whatsNew, newsAndEvents, classics, inDepth]) => {
      this.setState({banners, whatsNew: whatsNew.posts, newsAndEvents: newsAndEvents.posts, classics: classics.locations, inDepth: inDepth.locations})
    }).catch(error => {
      console.log(error)
      notification.error({ message: 'Something went wrong.'});
    });
  }

  render(){
    const { banners, whatsNew, newsAndEvents, classics, inDepth } = this.state;

    return (
      <div id="homepage">
        <div id="homepage_banner">
            <Banners 
              banners={banners} 
              previousArrowIcon={<Icon path={mdiChevronLeft} size="55px" />} 
              nextArrowIcon={<Icon path={mdiChevronRight} size="55px" />}/>
            <SearchBarWidget/>
        </div>
        
        <DestinationsHighlight locationGroupCodes={['GD_Standard', 'GD_In_Depth']}/>

        <div id="gd-classic">
          <LocationTabs 
            locations={classics}
            showMore={true}
            showMoreLink="web/series-tour/gd-classics"
            header={
              <div className="location-tabs_header">
                <span className="title">
                  <img src="/iceholidays-assets/images/gd-logo_round.png" alt="GD Logo" />
                  GD Classic
                </span>
                {/* <span className="subtitle">4 stars getaway to your ideal vacation in the world</span> */}
              </div>
            } 
            navigators={true}
            additionalParams={{key: 'brands', value: ['GD_Standard']}}/>
        </div>

        <div id="gd-indepth">
          <LocationTabs 
            locations={inDepth}
            showMoreLink="web/series-tour/gd-indepth"
            showMore={true}
            header={
              <div className="location-tabs_header">
                <span className="title">
                  <img src="/iceholidays-assets/images/gd-logo_round.png" alt="GD Logo" />
                  GD In-Depth
                </span>
                {/* <span className="subtitle">immerse your body, mind, and soul in the unique culture and colours of the locality.</span> */}
              </div>
            } 
            navigators={true}
            additionalParams={{key: 'brands', value: ['GD_In_Depth']}}/>
        </div>

        {/* <div id="whats-new" className="section">
          <div className="section-header">
            <h1> What’s New?  </h1>
            <Button href="/web/new-posts" type="primary" className="section-header-button">
              <span>EXPLORE  more</span>
              <Icon path={mdiChevronRight} size={1} />
            </Button>
          </div>
          <div className="section-body new-posts">
            {
              whatsNew.map(item => (
                <Link key={item.id} to={`/web/new-posts/${item.id}`}>
                  <Card cover={<img alt={item.title} src={item.thumbnail} />}>
                      <Meta title={item.title} description={
                        <Flex align="center" justify="space-between">
                          <div>
                            <div> {item.publishedDate} </div>
                            <div> {item.summary} </div>
                          </div>
                          <Icon path={mdiMenuRight} size="40px" />
                        </Flex>
                      } />
                  </Card>
                </Link>
              ))
            }
          </div>
        </div> */}

        <div id="news-and-events" className="section">
          <div className="section-header">
            <h1> News & Events  </h1>
            <Button href="/web/blogs?type=news_and_events" type="primary" className="section-header-button">
              <span>See  more</span>
              <Icon path={mdiChevronRight} size={1} />
            </Button>
          </div>
          <div className="section-body">
            {
              newsAndEvents.map(item => (
                <Card key={item.id} cover={<img alt={item.title} src={item.thumbnail} />} variant="borderless">
                    <Meta title={item.title} description={
                      <Flex align="center" justify="space-between">
                        <div>
                          <div> {item.publishedDate} </div>
                        </div>
                        <Link to={`/web/blogs/${item.id}`}>Read more</Link>
                      </Flex>
                    } />
                </Card>
              ))
            }
          </div>
        </div>

      </div>
    )
  }
}
